import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-downcode",
  "use": "icon-downcode-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-downcode\"><defs><style type=\"text/css\"></style></defs><path d=\"M898.54 280.54L512 667.09 125.46 280.54a36 36 0 0 0-50.92 50.92l412 412A35.92 35.92 0 0 0 512 754a35.9 35.9 0 0 0 18-4.84l1.16-0.71a36 36 0 0 0 6.27-5l412-412a36 36 0 0 0-50.91-50.92z\" p-id=\"7586\" fill=\"#999999FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol